<template>
    <div class="fields-flow-item mr-3">
        <div class="task-field">
            <div class="global-label">{{ $t('Billing') }}</div>
            <div>
                <v-menu
                    v-model="isMenuOpen"
                    offset-y
                >
                    <template #activator="{ on }">
                        <div tabindex="0" class="disp cursor-pointer" v-on="on" @click="$emit('click')">
                            <div class="d-flex align-center h-100">
                                <div class="val flex-grow-1 ml-2 font-weight-medium">
                                    {{ selectedText }}
                                </div>
                                <icon
                                    icon="ChevronDown"
                                    small
                                    :color="isMenuOpen ? 'primary' : 'n3'"
                                />
                            </div>
                        </div>
                    </template>
                    <div class="d-flex">
                        <v-list dense>
                            <v-list-item
                                v-for="(item, index) in items"
                                :key="index"
                                class="menu-list-item"
                                :class="billBy === item.value ? 'primary lighten-2' : ''"
                                style="height: 32px !important; min-height: 32px !important;"
                                @click="onUpdateBillBy($event, item)"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ item.text }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <div
                            @click.stop=""
                        >
                            <v-date-picker
                                v-if="billBy === 'custom_date'"
                                :value="billAt"
                                :locale="formatting.culture"
                                :first-day-of-week="formatting.first_week_day"
                                no-title
                                scrollable
                                hide-details
                                class="elevation-0"
                                @input="onDateChosen"
                            />
                        </div>
                    </div>
                </v-menu>
            </div>
            <div v-if="errorMessages" class="details error--text">
                {{ errorMessages }}
            </div>
        </div>
    </div>
</template>

<script>
import {$t} from "@/i18n";
import {computed, ref} from "@vue/composition-api";
import AppModule from "@/store/modules/app";
import {formatDate} from "@/plugins/formatting";

export default {
    name: "TaskBillBy",
    components: {},
    props: {
        errorMessages: {
            type: String,
            default: null
        },
        billBy: {
            type: String,
            default: null
        },
        billAt: {
            type: String,
            default: null
        }
    },
    setup(props, ctx) {
        const {formatting} = AppModule();
        const isMenuOpen = ref(false);

        const items = computed(() => {
            return [
                {text: 'Default', value: null},
                {text: $t('Task start date'), value: 'task_start'},
                {text: $t('Task due date'), value: 'task_due'},
                {text: $t('Task finish'), value: 'task_finish'},
                {text: $t('Custom date'), value: 'custom_date'},
                {text: $t('Never'), value: 'never'}
            ]
        })

        const selectedText = computed(() => {
            const item = items.value.find(x => x.value === props.billBy)

            if (item && item.value === 'custom_date') {
                return props.billAt ? formatDate(props.billAt) : item.text
            }

            return item ? item.text : ''
        })

        const onUpdateBillBy = (e, item) => {
            if (item.value === 'custom_date') {
                e.stopPropagation()
            }

            ctx.emit('update-bill-by', item.value)
        }

        const onDateChosen = (date) => {
            ctx.emit('update-bill-at', date)
            isMenuOpen.value = false
        }

        return {
            items,
            selectedText,
            onUpdateBillBy,
            formatting,
            isMenuOpen,
            onDateChosen
        }
    }
}
</script>
